interface AutoListenControllerDeps {
  startListening: () => Promise<void>;
  isListening: () => boolean;
}

export function createHandsFreeAutoListenController({
  startListening,
  isListening,
}: AutoListenControllerDeps) {
  let previousPlayingId: string | null = null;
  let hasStartedListening = false;
  let restartTimeoutId: ReturnType<typeof setTimeout> | null = null;

  function clearRestartTimeout() {
    if (restartTimeoutId !== null) {
      clearTimeout(restartTimeoutId);
      restartTimeoutId = null;
    }
  }

  function onCurrentPlayingIdChange(
    currentPlayingId: string | null,
    isEligible: boolean
  ) {
    clearRestartTimeout();

    if (!isEligible) {
      previousPlayingId = null;
      return;
    }

    const wasPlaying = previousPlayingId !== null;
    const isNowStopped = currentPlayingId === null;

    if (wasPlaying && isNowStopped && !isListening()) {
      restartTimeoutId = setTimeout(() => {
        startListening().catch(() => {
          // Silently handle errors - user can manually start if needed
        });
      }, 300);
      return;
    }

    previousPlayingId = currentPlayingId;
  }

  function onEligibilityChange(isEligible: boolean) {
    if (isEligible && !hasStartedListening) {
      hasStartedListening = true;
      startListening().catch(() => {
        // Silently handle errors
      });
    }
  }

  function stop() {
    clearRestartTimeout();
  }

  return { onCurrentPlayingIdChange, onEligibilityChange, stop };
}
